import { gql } from "@apollo/client";

export const UPDATE_APP_VERSION = gql`
  mutation UpdateAppVersion(
    $id: Long!
    $type: String!
    $versionCode: Int!
    $versionName: String!
    $url: String!
    $isForceUpdate: Boolean!
    $forceUpdateVersionCode: Int
    $enabledAt: String
    $description: String
  ) {
    updateAppVersion(
      id: $id
      type: $type
      versionCode: $versionCode
      versionName: $versionName
      url: $url
      isForceUpdate: $isForceUpdate
      forceUpdateVersionCode: $forceUpdateVersionCode
      enabledAt: $enabledAt
      description: $description
    ) {
      id
      versionCode
      versionName
      url
      isForceUpdate
      forceUpdateVersionCode
      enabledAt
      description
      type
    }
  }
`;
